import { gsap, ScrollTrigger } from "@/composeables/gsap"

function waitForCanPlay(video) {
    return new Promise((resolve) => {
        if (video.readyState >= 3) {
            resolve(video);
        } else {
            video.addEventListener("canplay", () => resolve(video), { once: true });
        }
    });
}

function createZoomAnimation(section) {
    const qs = gsap.utils.selector(section);
    const media = qs(".section-text-on-image__media .media");
    const overlay = qs(".section-text-on-image__media-overlay");
    const video = section.querySelector('video[data-scroll-trigger="true"]')

    gsap.set(overlay, {
        willChange: 'opacity'
    })
    gsap.set(media, {
        willChange: 'transform'
    })

    const fadeOutOverlay = gsap.fromTo(
        overlay,
        { autoAlpha: 1 },
        { autoAlpha: 0.3 }
    )
    const scaleMedia = gsap.fromTo(
        media,
        { scale: 2.5 },
        { scale: 1 }
    );

    const timeline = gsap
        .timeline()
        .addLabel("start")
        .add([fadeOutOverlay, scaleMedia])
        .addLabel("end")

    const trigger = ScrollTrigger.create({
        trigger: section,
        markers: false,
        start: "top bottom",
        end: "top top",
        invalidateOnRefresh: true,
        animation: timeline,
        scrub: true,
    });

    if (!video) { return }

    const videoTrigger = ScrollTrigger.create({
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        markers: false,
        invalidateOnRefresh: true,
        onEnter(self) {
            waitForCanPlay(video)
                .then((video) => video.play())
        },
        onLeave(self) {
            video.pause()
        },
        onLeaveBack(self) {
            video.pause()
        },
        onEnterBack(self) {
            waitForCanPlay(video)
                .then((video) => video.play())
        },

    })

    if (videoTrigger.isActive) {
        waitForCanPlay(video)
            .then((video) => video.play())
    } else {
        video.pause()
    }

}

function createParallaxAnimation(section) {
    const qs = gsap.utils.selector(section);
    const media = qs(".media img");

    const direction = 1;
    const percent = 30;
    const scale = 1.6;

    gsap.set(media, {
        willChange: 'transform'
    })

    const tween = gsap.fromTo(
        media,
        {
            y: (1 * direction * percent) + '%',
            scale: scale,
        },
        {
            y: (-1 * direction * percent) + '%',
            scale: scale,
            ease: "none",
        }
    )

    const timeline = gsap
        .timeline()
        .addLabel("start")
        .add(tween)
        .addLabel("end")

    ScrollTrigger.create({
        trigger: section,
        markers: false,
        start: "top bottom",
        end: "bottom top",
        invalidateOnRefresh: true,
        animation: timeline,
        scrub: true,
    });
}

export const init = () => {
    gsap.utils
        .toArray('.section-text-on-image[data-variant="zoom"]')
        .forEach(createZoomAnimation);

    gsap.utils
        .toArray('.section-text-on-image[data-variant="parallax"]')
        .forEach(createParallaxAnimation);
};

export default init;
